<template>
  <transition name="fade">
    <div v-if="open" class="document-modal-backdrop" @click="close">
      <div class="document-modal" @click.stop>
        <div class="document-modal-header">
          <h2>Документы</h2>
          <button @click="close" class="close-button">&times;</button>
        </div>
        <div class="document-modal-body" v-if="documents.length > 0">
          <ul>
            <li v-for="doc in documents" :key="doc.id">
                <div class="document-item">
                    <div class="document-name">
                        <div class="name-line"></div>
                        <span>{{ doc.name }}</span>
                    </div>
                    <a href="#" @click.prevent="downloadDocument(doc)" class="download-button">
                        <img src="../assets/images/download_icon.svg" alt="download" />
                        Скачать
                    </a>
                </div>
            </li>
          </ul>
        </div>
        <div class="document-modal-body" v-else>
          <p>Нет доступных документов.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';

const toaster = useToast();

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    },
    async downloadDocument(doc) {
      try {
        const urlParts = doc.download_url.split('/');
        const apiPath = '/' + urlParts.slice(-4).join('/');

        const response = await axios.get(apiPath, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = doc.name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error("Error downloading document:", error);
        toaster.error("Ошибка при скачивании документа", {
            position: "top-right"
        });
      }
    }
  },
  watch: {
    open(isOpen) {
        console.log(this.documents);
        
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  mounted() {
    const handleKeyup = (event) => {
      if (event.keyCode === 27 && this.open) {
        this.close();
      }
    };
    document.addEventListener('keyup', handleKeyup);
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keyup', handleKeyup);
    });
  },
};
</script>

<style scoped>
.document-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.document-modal {
  background: #FFF;
  padding: 0;
  border-radius: 8px;
  width: 700px;
  max-width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.document-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px 8px 0 0;
}

.document-modal-header h2 {
  margin: 0;
  font-size: 1.8rem;
}

.close-button {
  border: none;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  color: #818181;
}
.document-modal-body p{
    padding: 0 15px;
}

.document-modal-body ul {
  list-style-type: none;
  padding: 0 20px;
}

.document-modal-body li {
  margin-bottom: 15px;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
}

.document-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.document-name {
    display: flex;
    align-items: center;
    gap: 10px;
}

.name-line {
    width: 5px;
    height: 30px;
    background-color: #007BFF;
    border-radius: 3px;
}

.download-button {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 15px;
    border-radius: 8px;
    text-decoration: none;
    color: #333;
    font-weight: 500;
    border: 2px solid #F5F5F5;
}

.download-button img {
    width: 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
